import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { postRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../../components/CustomAlert';
import RedIconSVG from '../SVG/RedIconSVG';
import CloseIcon from '../SVG/CloseIcon';
import { reloadContactList, reloadContactOverview } from '../../store/actions/reduxAction';

const ContactDelete = (props) => {
  const {
    modalDeleteShow,
    setModalDeleteShow,
    selectedRows,
    setSelectedRows,
    access_token,
    reloadContactList,
    reloadContactOverview,
  } = props;
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    if (modalDeleteShow === true) {
      setSelectedContacts(selectedRows);
    }
  }, [modalDeleteShow]);

  const handleSave = () => {
    const data = {
      contacts: selectedRows,
    };

    postRequest('/v2/contacts-delete-contacts', data, access_token.token, (res) => {
      if (res.success) {
        // Handle success if needed
        reloadContactList();
        reloadContactOverview();
        handleDeleteConfirmClose();
        setSelectedRows([]);
        setAlertState({
          message: 'Selected contacts were deleted successfully',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: 'There was an error deleting your selected contacts!',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const handleDeleteConfirmClose = () => {
    setModalDeleteShow(false);
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal
        show={modalDeleteShow}
        className="modal-delete"
        animation={true}
        onHide={handleDeleteConfirmClose}
        centered
      >
        <Modal.Body>
          <CloseIcon handleModalClose={handleDeleteConfirmClose} />
          <RedIconSVG />
          <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
            Delete Selected Contacts
          </Modal.Title>
          Are you sure you want to delete the
          <br />
          selected contacts? This action cannot be
          <br />
          undone
          <br />
          <div>Delete {selectedContacts.length} Contact(s)?</div>
          <div className="d-flex justify-content-center" style={{ marginTop: 24, gap: 16 }}>
            <Button
              variant="outline-secondary"
              onClick={handleDeleteConfirmClose}
              style={{ minWidth: 160 }}
            >
              Cancel
            </Button>
            <Button variant="danger" style={{ minWidth: 160 }} onClick={handleSave}>
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  const { access_token, user } = state.auth;

  return {
    access_token,
    user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reloadContactList: () => dispatch(reloadContactList()),
  reloadContactOverview: () => dispatch(reloadContactOverview()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactDelete);
